module.exports = __webpack_public_path__ + "img/Salai-logo1.0fcd6320.png";